export const REQUEST_TYPE_CONFIG: Record<string, { label: string; color: string; dotClass: string }> = {
  rate_change: { label: "Rate Change", color: "text-red-600", dotClass: "bg-red-500" },
  low_margin: { label: "Low Margin", color: "text-amber-600", dotClass: "bg-amber-500" },
  change_order: { label: "Change Order", color: "text-amber-600", dotClass: "bg-amber-500" },
  retainage_release: { label: "Retainage Release", color: "text-blue-600", dotClass: "bg-blue-500" },
  draw_approve: { label: "Draw Approval", color: "text-green-600", dotClass: "bg-green-500" },
  // AP bill approvals — "invoice" terminology is reserved for AR
  invoice_approve: { label: "Bill Approval Request", color: "text-green-600", dotClass: "bg-green-500" },
  bill_approve: { label: "Bill Approval Request", color: "text-green-600", dotClass: "bg-green-500" },
  void_record: { label: "Void Record", color: "text-red-600", dotClass: "bg-red-500" },
  backcharge: { label: "Backcharge", color: "text-red-600", dotClass: "bg-red-500" },
  reopen_wo: { label: "Reopen WO", color: "text-amber-600", dotClass: "bg-amber-500" },
  vendor_approve: { label: "Vendor Approval", color: "text-blue-600", dotClass: "bg-blue-500" },
  other: { label: "Other", color: "text-muted-foreground", dotClass: "bg-muted-foreground" },
};

export const STATUS_STYLES: Record<string, string> = {
  pending: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
  approved: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  rejected: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  info_requested: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  forwarded: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  withdrawn: "bg-muted text-muted-foreground",
  expired: "bg-muted text-muted-foreground",
};

export const AUDIT_ACTION_CONFIG: Record<string, { label: string; dotClass: string }> = {
  created: { label: "Request created", dotClass: "bg-blue-500" },
  sent: { label: "Submitted for approval", dotClass: "bg-amber-500" },
  submitted: { label: "Submitted for approval", dotClass: "bg-amber-500" },
  approved: { label: "Approved", dotClass: "bg-green-500" },
  rejected: { label: "Rejected", dotClass: "bg-red-500" },
  info_requested: { label: "Info requested", dotClass: "bg-blue-500" },
  requested_changes: { label: "Changes requested", dotClass: "bg-blue-500" },
  forwarded: { label: "Forwarded", dotClass: "bg-purple-500" },
  escalated: { label: "Escalated", dotClass: "bg-red-500" },
  withdrawn: { label: "Withdrawn", dotClass: "bg-muted-foreground" },
  completed: { label: "Completed", dotClass: "bg-green-500" },
  expired: { label: "Expired", dotClass: "bg-muted-foreground" },
  reminder_sent: { label: "Reminder sent", dotClass: "bg-amber-500" },
  viewed: { label: "Viewed", dotClass: "bg-muted-foreground" },
};

// Bill status display labels (AP lifecycle)
export const BILL_STATUS_CONFIG: Record<string, { label: string; color: string }> = {
  draft:     { label: "Draft Bill",              color: "bg-muted text-muted-foreground" },
  submitted: { label: "Submitted for Approval",  color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400" },
  approved:  { label: "Approved Bill",           color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" },
  scheduled: { label: "Scheduled for Payment",   color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400" },
  paid:      { label: "Paid Bill",               color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400" },
  rejected:  { label: "Rejected",                color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400" },
  voided:    { label: "Voided",                  color: "bg-muted text-muted-foreground" },
  void:      { label: "Voided",                  color: "bg-muted text-muted-foreground" },
  sent:      { label: "Submitted for Approval",  color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400" },
};
